import React, { useState } from "react";
import cx from "clsx";
import { TimerIcon } from "../../../../../../../../../assets/Icons/TimerIcon";
import styles from "./styles.module.scss";
import { getPathParams } from "../../../../../utilities";
import { useClientQuery } from "../../../../../../../../../api/queries/useClientQuery";
import { UpdateExpirationDateModal } from "./shared/UpdateExpirationDateModal";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";

export function Timer({
  documentId,
  expireSoon,
  name,
  date,
  type,
  expirationDateEditor,
  lastEditedExpirationDate,
  expirationDate,
  typeLabel,
}) {
  var { patientId } = getPathParams();
  var { 0: isOpen, 1: setIsOpen } = useState(false);
  var { data: patient } = useClientQuery({ clientId: patientId });
  var { tClients: t } = useAppTranslation.Clients();

  return (
    <>
      <button
        title={t("documents.expiration.timer")}
        className={cx(styles.root, {
          [styles.expireSoon]: expireSoon,
        })}
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <TimerIcon width="18px" />
      </button>
      {isOpen && (
        <UpdateExpirationDateModal
          isOpen
          onClose={() => setIsOpen(false)}
          patientId={patientId}
          patientName={patient?.fullName}
          document={{
            name,
            date,
            type,
            expirationDateEditor,
            lastEditedExpirationDate,
            documentId,
            expirationDate,
            label: typeLabel,
          }}
        />
      )}
    </>
  );
}
